import styled from "styled-components";
import SectionTitle from "../../../components/SectionTitle";

export default styled(SectionTitle)`
    padding: 0 15px;
`;
